<template>
    <modal @close="$emit('close')" :max_width="655" :wide="true">
        <div class="pl-6 pr-6 pt-16 pb-12 relative">
            <p class="font-bold text-lg md:text-2xl">Добавить участника</p>
            <p class="text-xs md:text-sm mt-5">
              Поделитесь ссылкой с участником, чтобы пригласить его в команду <br><span class="text-brand-light" style="word-break: break-all">{{team_name}}</span>.<br><br><span class="text-brand-light">Внимание!</span> Ссылка действительна для 1 участника.
            </p>
            <div class="mt-10 flex justify-between">
                <div class="w-64 sm:w-92 mr-4">
                    <p class="break-words text-brand-light font-bold">{{linkToString}}</p>
                </div>
                <div @click.stop.prevent="copyText">
                    <img width="20" class="cursor-pointer sm:hidden hover-up" src="@/assets/SVG/copy.svg" alt="">
                    <button class="copy-button hidden sm:block">Копировать</button>
                </div>
            </div>
            <img @click="$emit('close')" class="hover:text-grey-darkest cursor-pointer h-4 absolute pin-t pin-r m-5 copy-image" src="@/assets/SVG/cross-partners.svg"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/views/modals/base-modal';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'InviteModal',
  props: ['link', 'team_name'],
  components: { Modal },
  methods: {
    ...mapActions(['selectShowModal', 'selectModalText']),
    copyText() {
      this.$clipboard(this.linkToString);
      this.selectModalText('Ссылка скопирована');
      this.selectShowModal(true);
    },
  },
  computed: {
    linkToString() {
      return `${window.location.hostname}/invite${this.link.toString()}`;
    },
    mobile() {
      return window.innerWidth < 840;
    },
  },
};

</script>

<style scoped>
#copy {
  opacity: 0;
}
.copy-button{
  background: #BD006C;
  border-radius: 45px;
  width: 10rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #FFFFFF;
  padding: 12px 20px;
  margin-top: 0.5rem;
  outline: none;
}
.mozgo-butt:focus {
  outline: 0
}
@media (max-width: 840px){}

</style>
